<template>
    <div>
        <!-- clients -->
        <div class="message">
            <div class="message-header">
                <p>Clients</p>
            </div>
            <div class="message-body">
                <div class="field">
                    <div class="control">
                        <label class="checkbox">
                            <input v-model="showDead" type="checkbox" /> Show dead clients
                        </label>
                    </div>
                </div>
                <div class="field">
                    <div class="control">
                        <router-link :to="{ name: 'client-create' }" class="button is-primary">Create client</router-link>
                    </div>
                </div>
            </div>
        </div>

        <!-- clients -->
        <div v-if="stats && clients && clients.length" class="dashboard-container">
            <template v-for="client in clients">
                <router-link
                    v-if="!client.dead || showDead"
                    :key="client.id"
                    :to="{ name: 'players', params: { clientId: client.id } }"
                    class="box"
                >
                    <p class="title is-5">
                        {{client.name}},
                        <span
                            class="has-text-weight-normal"
                        >{{getStats(client.id).playersStats.playersCount}} players</span>
                    </p>
                    <p class="subtitle is-6">
                        <a
                            :href="client.settings.generalSettings.siteUrl"
                            target="_blank"
                            v-on:click.stop
                        >{{client.settings.generalSettings.siteUrl}}</a>
                    </p>

                    <template v-if="getStats(client.id).items24h.length">
                        <p class="tag">24h profit</p>
                        <div v-for="s in getStats(client.id).items24h" :key="`24h_${s.currency}`">
                            {{s.currency}}
                            <span
                                :class="{'has-text-success': s.in > s.out, 'has-text-danger has-text-bold': s.in < s.out}"
                            >
                                <span v-show="s.in > s.out">+</span>
                                <span v-show="s.in < s.out">-</span>
                                {{Math.abs(s.in - s.out) | currency(s.currency)}}
                            </span>
                        </div>
                    </template>
                    <template v-if="getStats(client.id).items3d.length">
                        <p class="tag">72h profit</p>
                        <div v-for="s in getStats(client.id).items3d" :key="`3d_${s.currency}`">
                            {{s.currency}}
                            <span
                                :class="{'has-text-success': s.in > s.out, 'has-text-danger has-text-bold': s.in < s.out}"
                            >
                                <span v-show="s.in > s.out">+</span>
                                <span v-show="s.in < s.out">-</span>
                                {{Math.abs(s.in - s.out) | currency(s.currency)}}
                            </span>
                        </div>
                    </template>
                </router-link>
            </template>
        </div>
    </div>
</template>

<script>
import state from '../state';
import dt from '../services/datetime.service';
import statsService from '../services/stats.service';
import clientService from '../services/client.service';
import systemSettingsService from '../services/systemsettings.service';

export default {
    name: 'dashboard',
    data() {
        return {
            stats: [],
            systemSettings: null,
            showDead: false
        };
    },
    computed: {
        clients() {
            return state.clients.get();
        }
    },
    async mounted() {
        this.systemSettings = await systemSettingsService.get();

        let from24h = dt.local().add(-24, 'hours').utc().toISOString();
        let to24h = dt.local().endOf('day').utc().toISOString();
        let from3d = dt.local().add(-72, 'hours').utc().toISOString();
        let to3d = dt.local().endOf('day').utc().toISOString();

        await clientService.ensure();
        await this.clients.forEach(async (c) => {
            this.stats.push({
                clientId: c.id,
                items24h: await this.loadStats(c.id, from24h, to24h),
                items3d: await this.loadStats(c.id, from3d, to3d),
                playersStats: await this.loadPlayersStats(c.id)
            });
        });
    },
    methods: {
        getStats(clientId) {
            return (
                this.stats.filter((s) => s.clientId == clientId)[0] || {
                    clientId: clientId,
                    items24h: [],
                    items3d: [],
                    playersStats: { playersCount: 0 }
                }
            );
        },
        async loadStats(clientId, from, to) {
            let st = await statsService.getClientProfitStats(clientId, from, to, ['Pin', 'PaymentSystem']);
            let result = [];
            st.totals.forEach((t) => {
                t.currencies.forEach((c) => {
                    let cStat = result.filter((r) => r.currency == c.currency)[0];
                    if (!cStat) {
                        cStat = {
                            currency: c.currency,
                            in: 0,
                            out: 0
                        };
                        result.push(cStat);
                    }
                    cStat.in += c.in;
                    cStat.out += c.out;
                });
            });
            return result;
        },
        async loadPlayersStats(clientId) {
            return await statsService.getPlayerStats(clientId);
        },
        async emailErrorIsFixed() {
            this.systemSettings.email.lastEmailError = '';
            await systemSettingsService.save(this.systemSettings);
            this.systemSettings = await systemSettingsService.get();
        }
    }
};
</script>
<style>
.dashboard-container {
    margin-bottom: 4rem;
}
</style>



// WEBPACK FOOTER //
// front/src/components/dashboard.vue